import React from 'react';
import { supabase } from '../lib/supabase';

const ResourceDeactivated = () => {
  const handleLogout = async () => {
    try {
      // Clear any auth data
      if (supabase) {
        await supabase.auth.signOut();
      }
      
      // Also clear local storage as a fallback
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('sb-') || key.startsWith('supabase.auth.')) {
          localStorage.removeItem(key);
        }
      });
      
      // Redirect to login
      window.location.href = '/login';
    } catch (error) {
      console.error('Error signing out:', error);
      // If sign out fails, just redirect anyway
      window.location.href = '/login';
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center max-w-md mx-auto p-6 bg-white rounded-lg shadow-md">
        <div className="h-12 w-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">Account Deactivated</h1>
        <p className="text-gray-600 mb-6">
          Your account has been deactivated. Please contact your administrator for assistance.
        </p>
        <button
          onClick={handleLogout}
          className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-gray-900 border border-transparent rounded-md shadow-sm hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        >
          Return to Login
        </button>
      </div>
    </div>
  );
};

export default ResourceDeactivated; 